export default {
  actions: {
    getSelectedTask: () => void 0,
    getSelectedTaskId: () => void 0,
    setSelectedTaskId: () => {},
    setEndTaskWarning: () => {},
    setLastDialedNumber: () => {},
    matchExistingCustomerProfile: () => {},
    forceClearAllTasks: () => {},
    deleteExistingCustomerProfile: () => {},
    rejectTask: () => Promise.resolve(),
    acceptTask: () => Promise.resolve(),
    endInitialConnection: () => Promise.resolve(),
    removeTask: () => Promise.resolve(),
    makeOutboundCall: () => Promise.resolve(),
    onTransfer: () => Promise.resolve(),
    onTransferToQueueOrAgent: () => Promise.resolve(),
    onTransferToExternalNumber: () => Promise.resolve(),
    holdCall: () => Promise.resolve(),
    resumeCall: () => Promise.resolve(),
    hangupAgent: () => Promise.resolve(),
    onJoinConference: () => Promise.resolve(),
    sendMessage: () => {},
    sendAttachment: () => {},
    downloadAttachment: () => Promise.resolve(void 0),
    sendTypingEvent: () => {},
    getChatTranscripts: () => Promise.resolve(),
    getActiveCallTask: () => undefined,
    onSwapConferenceCall: () => Promise.resolve(),
    holdConferenceConnection: () => Promise.resolve(),
    resumeConferenceConnection: () => Promise.resolve(),
    endConferenceConnection: () => Promise.resolve(),
    muteConnection: () => Promise.resolve(),
    unmuteConnection: () => Promise.resolve(),
    setTaskContent: () => {},
    addDraftTask: () => {},
    removeDraftTask: () => {},
    monitorTask: () => Promise.resolve(),
    bargeInTask: () => Promise.resolve(),
    pauseTask: () => Promise.resolve(),
    resumeTask: () => Promise.resolve(),
    setUnreadMessage: () => {},
  },
  state: {
    tasks: [],
    selectedTaskId: void 0,
    onActiveCall: false,
    lastDialedNumber: '',
    hasPreviewDialingTask: false,
    hasConnectingTask: false,
    hasConnectingInboundTask: false,
    hasConnectingVoiceTask: false,
    hasConnectingInboundVoiceTask: false,
    isCallInACW: false,
    initialisingTasks: true,
  },
};
